import { makeStyles } from '@material-ui/core/styles'
import { createStyles, Theme } from '@material-ui/core'
import { transition } from '../../shared/style-settings'

export const useAppDialogStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogTitle: {
      paddingRight: theme.spacing(9),

      '& > h2': {
        display: 'flex',
        alignItems: 'center',
      },

      '& .MuiSvgIcon-root': {
        marginRight: theme.spacing(0.75),
      },
    },

    dialogContent: {
      display: 'flex',
      alignItems: 'flex-start',
    },

    dialogMessage: {
      flex: 1,
      minWidth: 0,
      margin: 0,
      fontWeight: 400,
    },

    dialogIcon: {
      flexShrink: 0,
      display: 'flex',
      alignItems: 'flex-start',
      paddingTop: theme.spacing(0.25),
      marginRight: theme.spacing(2),

      '& .MuiSvgIcon-root': {
        fontSize: '3rem',
      },
    },

    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
      transition,

      '&:hover': {
        color: theme.palette.grey[700],
        backgroundColor: theme.palette.action.hover,
      },

      '& .MuiSvgIcon-root': {
        marginRight: '0!important',
      },
    },
  })
)
